<div class="containerMarginX tech-content"><!--tech-content containerMarginY-->
  <tech-back class="ml-2" [direction]="'/settings'"></tech-back>
  <!-- Header -->
  <div class="tech-headers">
    <div>
      <h2 class="ml-2">{{ 'k001092' | translate }}</h2>
      <!--Documentación-->
    </div>
    <div class="icon-filter pointer colorblue new" [ngClass]="{'borderDropDownList': borderDropDownList}"  *ngIf="showFilter">
      <fa-icon [icon]="panelOpenState ? fasSlidersH : farSlidersH"></fa-icon>
      <mat-select
        [(value)]="selectedElement"
        placeholder="{{ 'k000317' | translate }}"
        (selectionChange)="changeDocument($event.value)"
        class="new margen colorblue"
        ><!--Todo-->
        <!--class="col-xs-12 col-md-5"-->
        <!-- Token: Todo -->
        <mat-option
          *ngFor="let notificationItem of arrtypenotification"
          [value]="notificationItem.value"
        >{{ notificationItem.label }}
        </mat-option>
      </mat-select>
    </div>
  </div>
    <!--
    <div
      class="icon-filter pointer"
      [matMenuTriggerFor]="menuFilter"
      #matMT="matMenuTrigger"
      [ngClass]="{'borderDropDownList': borderDropDownList}"
      *ngIf="showFilter"
    >
      <button mat-button color="primary">
        <fa-icon [icon]="matMT.menuOpen ? fasSlidersH : farSlidersH"></fa-icon>
        <span class="ml-2" [ngClass]="{ bold: matMT.menuOpen === true }">{{
          'k000317' | translate
        }}</span>
      </button>

      <mat-menu #menuFilter="matMenu" xPosition="before">
        <button
          mat-menu-item
          *ngFor="let notificationItem of arrtypenotification"
          (click)="changeDocument(notificationItem.value)"
        >
          {{ notificationItem.label }}
        </button>
      </mat-menu>
        </div>
      -->
  <!-- Versión Desktop -->
  <div *ngIf="documentationList.length > 0 && !isMovil">
    <div class="contentTimeline">
      <div
      id="vertical-timeline"
      class="no-margins"
      #scrollMe
      [ngClass]="{
      'light-timeline': (documentationList.length > 0),
      'nonelight-timeline': (documentationList.length == 1)
      }"
      >
        <div
          id="vertical-timeline-block"
          class="no-margins"
           [ngClass]="{
           'light-timeline': (documentationList.length > 0),
           'nonelight-timeline': (documentationList.length == 1)
      }"
          *ngFor="let item of documentationList; let i = index"
        ><!--class="light-timeline no-margins" -->
          <div
            class="system"
            *ngIf="
              i === 0 ||
              documentationList[i - 1].groupedDate !== item.groupedDate
            "
          >
            <div class="time-stamp">{{ item.groupedDate }}</div>
          </div>
          <div class="vertical-timeline-block">
            <div [class]="item.ChannelClass">
              <fa-icon [icon]="item.Icon"></fa-icon>
            </div>
            <div
              [ngClass]="{
                white: 1 == 1,
                'vertical-timeline-content': 1 == 1,
                touchpointGrid2: item.isExpandable,
                touchpointGrid: !item.isExpandable
              }"
            >
              <div class="areaGridTitulo">
                <ng-container *ngIf="item.isExpandable">
                  <div
                    [ngClass]="{
                      'basic-other-container': panelOpenState,
                      'basic-other-container2': !panelOpenState
                    }"
                  >
                    <mat-expansion-panel
                      (opened)="panelOpenState = true"
                      (closed)="panelOpenState = false"
                    >
                      <mat-expansion-panel-header>
                        <mat-panel-title>
                          <span class="touchpointTitle c1"
                            >{{ item.Description }}
                          </span>
                          &nbsp;<span class="vertical-date-tw30"
                            >{{ item.DateString }}
                            <small> {{ item.TimeString }}</small>
                          </span>
                        </mat-panel-title>
                        <mat-panel-description> </mat-panel-description>
                      </mat-expansion-panel-header>
                      <div class="subitemdescription">
                        <hr />
                        <span class="estile">{{ item.ExtraData }} </span>
                      </div>
                    </mat-expansion-panel>
                  </div>
                </ng-container>

                <ng-container *ngIf="!item.isExpandable">
                  <span class="touchpointTitle c1"
                    >{{ item.Description }}
                  </span>
                  &nbsp;<span class="vertical-date-tw30"
                    >{{ item.DateString }}
                    <!--<small> {{ item.TimeString }}</small>-->
                  </span>
                </ng-container>
              </div>
              <div class="areaGridOptions pointer">
                <fa-icon
                  [icon]="['fal', 'file-download']"
                  size="lg"
                  class="coloricono"
                  (click)="documentdownloadid(item)"
                ></fa-icon>
              </div>
            </div>
            <!-- fin vertical-timeline-content (click)="drawer.toggle()" -->
          </div>
          <!--fin de vertical-timeline-block-->
        </div>
        <!--fin de vertical-timeline-block-->
      </div>
    </div>
    <!--fin de contentTimeline-->
  </div>

  <!-- Versión Móvil -->
  <div *ngIf="documentationList.length > 0 && isMovil" #scrollMe>
    <div class="white" *ngFor="let item of documentationList; let i = index">
      <div
        *ngIf="
          i === 0 || documentationList[i - 1].groupedDate !== item.groupedDate
        "
      >
        <div class="time-stamp demas">{{ item.groupedDate }}</div>
      </div>
      <div class="cardsContainer">
        <div class="imgContainer"><!--  class="redondeo" [style.background-color]="getChannelClassMovil(item.Type)"> -->
          <div
          [class]="item.ChannelClassMobile">
            <fa-icon [icon]="item.Icon"></fa-icon>
          </div>
        </div>
        <div class="contenido">
          <div class="touchpointGridM">
            <div class="areaGridTitulo">
              <!--multiline2-->
              <span class="touchpointTitle c1 multiline">{{
                item.Description
              }}</span>
            </div>
          </div>
        </div>
        <div class="time">
          <span class="vertical-date-tw30"
            >{{ item.DateString
            }}<!--<small>{{ item.TimeString }}</small>--></span
          >
        </div>
        <div class="icono pointer">
          <fa-icon
            [icon]="['fal', 'file-download']"
            size="lg"
            class="coloricono"
            (click)="documentdownloadid(item)"
          ></fa-icon>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="documentationList.length == 0" class="gridnodata">
    <div class="textonodata text-center">{{ 'k002559' | translate }}</div>
  </div>
</div>

